import { default as domainAmbienceResource } from './resource/services'
import { default as domainAmbience } from './ambience/services'
import { default as domainAmbienceCategory } from './category/services'

export default {
    domainAmbienceResource,
    domainAmbience,
    domainAmbienceCategory
}